import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const CustomAlert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Alert({ alert }) {
    const [open, setOpen] = React.useState(true);

    React.useEffect(() => {
        setOpen(true);
    }, [alert]);

    const handleClose = (event, reason) => {
        setOpen(false);
        if (reason === 'clickaway') return;
    };

    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <CustomAlert onClose={handleClose} severity={alert.variant || "info"} sx={{ width: '100%' }}>
                {alert.message}
            </CustomAlert>
        </Snackbar>
    );
}